import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState } from "react";
/**
 * React custom hook that returns the very first value passed to `initialState`,
 * even if it changes between re-renders.
 */

export function useConst(initialState) {
  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 1),
      sealed = _useState2[0];

  return sealed;
}